export default {
  executeButton: 'proposal-proposal-summary-execute-button',
  queueButton: 'proposal-proposal-summary-queue-button',
  cancelButton: 'proposal-proposal-summary-cancel-button',
};
